import React from "react";
import One1 from '../assets/cbu/01.jpeg'
import One2 from '../assets/cbu/02.jpeg'
import One3 from '../assets/cbu/03.jpeg'
import One4 from '../assets/cbu/04.jpeg'
import One5 from '../assets/cbu/05.jpeg'
import One6 from '../assets/cbu/06.jpeg'
import One7 from '../assets/cbu/07.jpeg'
import One8 from '../assets/cbu/08.jpeg'
import One9 from '../assets/cbu/09.jpeg'
import One11 from '../assets/cbu/11.jpeg'
import One12 from '../assets/cbu/12.jpeg'
import One13 from '../assets/cbu/13.jpeg'
import One14 from '../assets/cbu/14.jpeg'
import One15 from '../assets/cbu/15.jpeg'
import One16 from '../assets/cbu/16.jpeg'
import One17 from '../assets/cbu/17.jpeg'
import One18 from '../assets/cbu/18.jpeg'
import One19 from '../assets/cbu/19.jpeg'
import One20 from '../assets/cbu/20.jpeg'
import "../css/Photo.css"

function Photo() {
  return ( 
    <section id="photo" class="bg-white">
          <div class="collage ">
            <div class="photo-block">
            <div class="photo-grid">
              <div class="photo"><img src={One1} alt=""  /></div>
              <div class="photo"><img src={One2} alt=""  /></div>
              <div class="photo"><img src={One3} alt=""  /></div>
              <div class="photo"><img src={One4} alt=""  /></div>
              <div class="photo"><img src={One5} alt="" /></div>
              <div class="photo"><img src={One6} alt="" /></div>
              <div class="photo"><img src={One7} alt="" /></div>
              <div class="photo"><img src={One8} alt="" /></div>
              <div class="photo"><img src={One9} alt="" /></div>
              <div class="photo"><img src={One20} alt=""  /></div>
              <div class="photo"><img src={One11} alt="" /></div>
              <div class="photo"><img src={One12} alt="" /></div>
              <div class="photo"><img src={One13} alt="" /></div>
              <div class="photo"><img src={One14} alt="" /></div>
              <div class="photo"><img src={One15} alt="" /></div>
              <div class="photo"><img src={One16} alt="" /></div>
              <div class="photo"><img src={One17} alt="" /></div>
              <div class="photo"><img src={One18} alt="" /></div>
              <div class="photo"><img src={One19} alt="" /></div>
              <div class="photo"><img src={One20} alt="" /></div>
              <div class="photo"><img src={One1} alt="" /></div>
              <div class="photo"><img src={One2} alt="" /></div>
              <div class="photo"><img src={One3} alt="" /></div>
              <div class="photo"><img src={One4} alt="" /></div>
              <div class="photo"><img src={One5} alt="" /></div>
              <div class="photo"><img src={One6} alt="" /></div>
              <div class="photo"><img src={One7} alt="" /></div>
              <div class="photo"><img src={One8} alt="" /></div>
              <div class="photo"><img src={One9} alt="" /></div>
              <div class="photo"><img src={One1} alt="" /></div>
              <div class="photo"><img src={One1} alt="" /></div>
              <div class="photo"><img src={One2} alt="" /></div>
              <div class="photo"><img src={One3} alt="" /></div>
              <div class="photo"><img src={One4} alt="" /></div>
              <div class="photo"><img src={One5} alt="" /></div>
              <div class="photo"><img src={One6} alt="" /></div>
              <div class="photo"><img src={One7} alt="" /></div>
              <div class="photo"><img src={One8} alt="" /></div>
              <div class="photo"><img src={One9} alt="" /></div>
              <div class="photo"><img src={One1} alt="" /></div>
              <div class="photo"><img src={One1} alt="" /></div>
              <div class="photo"><img src={One2} alt="" /></div>
              <div class="photo"><img src={One3} alt="" /></div>
              <div class="photo"><img src={One4} alt="" /></div>
              <div class="photo"><img src={One5} alt="" /></div>
              <div class="photo"><img src={One6} alt="" /></div>
              <div class="photo"><img src={One1} alt="" /></div>
              <div class="photo"><img src={One2} alt="" /></div>
              <div class="photo"><img src={One3} alt="" /></div>
              <div class="photo"><img src={One4} alt="" /></div>
              <div class="photo"><img src={One5} alt="" /></div>
              <div class="photo"><img src={One6} alt="" /></div>
              <div class="photo"><img src={One7} alt="" /></div>
              <div class="photo"><img src={One8} alt="" /></div>
            </div>
          </div>
         
        </div>
  </section>
  );
}
   
export default Photo;